import React from 'react'
import _ from 'lodash'
import apiService from '../../services/api-id-value-service'
import LtsMultiselectIdValue from './lts-multiselect-id-value'

// O formulario manda a lista de unidades escolhidas, mas o recurso aceita um id so (com 2 ou mais a URL fica
// /contasCorrentes/49,1262 e volta 404, sem opcoes). O back devolve todas as contas da empresa sem olhar a unidade.
export const carregarContasCorrentes = (oidsUnidades) =>
  apiService.getContasCorrentes(_.isArray(oidsUnidades) ? _.head(oidsUnidades) : oidsUnidades)

export default function LtsMultiselectContaCorrente(props) {
  return (
    <React.Fragment>
      <LtsMultiselectIdValue
        name={props.name}
        label={props.label}
        value={props.value}
        onChange={props.onChange}
        loadDataFn={carregarContasCorrentes}
        loadDataFnParam={props.loadDataFnParam}
      />
    </React.Fragment>
  )
}
